const Mn = require('backbone.marionette');
const _  = require('underscore');

module.exports = Mn.View.extend({
    template: _.template('<div></div>'),

    ui: {
        main_region: 'div'
    },

    regions: {
        main_region: '@ui.main_region'
    }
});
